var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroSpaceIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 849.84 682.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: #fcfcfc;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #fffe67;\n      }\n\n      .cls-6 {\n        fill: #fffea4;\n      }\n\n      .cls-7 {\n        fill: #e83433;\n      }\n\n      .cls-8 {\n        fill: #dce5ff;\n      }\n\n      .cls-9 {\n        fill: #d1daf9;\n      }\n\n      .cls-10 {\n        fill: #e20100;\n      }\n\n      .cls-11 {\n        fill: #1748e2;\n      }\n\n      .cls-12 {\n        fill: #25252d;\n      }\n\n      .cls-13, .cls-14 {\n        fill: #434356;\n      }\n\n      .cls-15 {\n        fill: #181a1f;\n      }\n\n      .cls-16 {\n        fill: #a2b6f3;\n      }\n\n      .cls-17 {\n        fill: #7491ee;\n      }\n\n      .cls-18 {\n        fill: #5fd8b2;\n      }\n\n      .cls-19 {\n        fill: url(#Unbenannter_Verlauf_14);\n      }\n\n      .cls-14 {\n        opacity: .3;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_14",
    "data-name": "Unbenannter Verlauf 14",
    x1: 789.07,
    y1: -173.07,
    x2: 856.83,
    y2: -173.07,
    gradientTransform: "translate(-309.73 871.28) rotate(-13.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b50403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#b80302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#cf0201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#dd0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e20100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.93,315.58l-35.92,120.08c-8.09,27.05,16.09,52.74,43.58,46.29l271.41-63.64c34.24-8.03,31.57-44.23,11.27-64.66l-83.49-86.91c-6.64-6.92-16.44-9.81-25.78-7.63l-161.25,37.81c-9.47,2.22-17.03,9.34-19.82,18.65Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M500.35,143.23c0,25.09-10.26,47.9-26.8,64.43-16.54,16.53-39.35,26.8-64.43,26.8H91.23C41.05,234.46,0,193.41,0,143.23c0-25.09,10.26-47.9,26.8-64.43,16.53-16.53,39.35-26.8,64.43-26.8H409.12c50.18,0,91.23,41.05,91.23,91.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M452.81,514.56l-.39,.09h-.01s-.47,.11-.47,.11h0s-32.12,7.54-32.12,7.54l.22,.23-51.73,12.13-90.26,21.17c-9.89,2.32-19.48,1.74-28.12-1.04-7.41-10.21-13.88-21.11-19.3-32.6-2.94,3.85-5.79,7.67-8.56,11.44-8.22-12.32-11.4-28.17-6.51-44.35l103.81-343.8c5.77-19.09,20.64-31.6,37.56-35.86,.19-.06,.38-.1,.57-.14,.1-.03,.2-.06,.3-.08h0s84.45,360.13,84.45,360.13l10.51,44.81,.05,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M626.83,474.04l-142,33.3,.09-.3-32.98,7.73L356.94,109.6c17.28-4.05,36.57,.45,50.46,15.24l245.83,261.81c27.77,29.58,13.11,78.12-26.39,87.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "484.93 507.03 484.83 507.34 419.18 522.73 418.96 522.5 484.93 507.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M295.06,315.55l-35.92,120.08c-8.09,27.05,16.09,52.74,43.58,46.29l271.41-63.64c34.24-8.03,31.57-44.23,11.27-64.66l-83.49-86.91c-6.64-6.92-16.44-9.81-25.78-7.63l-161.25,37.81c-9.47,2.22-17.03,9.34-19.82,18.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M356.56,342.54c-7.82-.23-15.26-5.47-18.13-12.74-1.25-3.17-1.67-6.77-.55-9.99,1.12-3.22,3.95-5.94,7.33-6.35,4.13-.51,7.91,2.3,10.78,5.3,4.17,4.35,7.53,9.47,9.88,15.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M418.87,322.01c-1.51-6.8-.82-14.06,1.93-20.46,1.27-2.94,3.1-5.84,5.96-7.29,4.37-2.23,10.12-.2,12.96,3.8,2.84,4,3.1,9.42,1.67,14.12s-4.35,8.79-7.5,12.56c-3.14,3.77-6.57,7.33-9.26,11.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M535.26,385.04c1.04,9.27-2.38,17.34-11.9,20.68-10.77,3.78-22.94,2.41-32.47-3.86-6.39-4.2-11.32-10.11-15.7-16.44-1.56-2.26-4.98-1.57-5.64,1.09-3.13,12.6-17.07,24.25-29.18,30.41-15.13,7.7-32.75,10.38-49.47,7.56-8.11-1.38-17.95-3.99-23.07-10.26-1.63-2-4.81-1.37-5.48,1.12-4.02,14.79-11.08,19.81-22.84,24.4-14.08,5.5-20.54,1.65-27.83-3.18-7.88-5.25-9.83-16.15-8.47-25.53,2.21-15.28,11.67-29.33,24.9-37.28,1.51-.9,1.96-2.83,1.05-4.33-3.85-6.36-4.68-12.24,.55-17.12,5.23-4.87,9.35-6.75,17.58-4.75,1.72,.47,3.52-.62,3.86-2.38,1.13-5.83,3.88-11.35,7.9-15.71,5.11-5.55,12.7-9.26,20.13-8.08,3.8,.61,7.3,1.96,9.69,4.14,2.17,1.98,5.54,1.74,7.32-.58,.81-1.06,1.73-2.16,2.77-3.41,3.66-4.42,9.1-7.56,14.85-7.5,6.04,.06,11.12,3.4,15.5,7.77,3.86,3.84,9.83,4.46,14.49,1.64,1.25-.76,2.57-1.39,3.95-1.88,4.53-1.59,7.51-2.31,11.48,.38,2.87,1.94,6.32,6.39,6.09,9.9-.12,1.76,1.18,3.29,2.95,3.34,5.94,.16,16.9,1.98,18.52,2.28,7.7,1.42,15.33,3.77,22.16,7.65,13.64,7.76,23.32,22.65,26.04,37.95,.12,.67,.22,1.34,.29,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.99,
    cy: 351.54,
    r: 12.61
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.26,
    cy: 362.26,
    r: 12.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.18,389.07c-4.16,.97-8.65,.53-12.47-1.36-1.35-.66-1.9-2.29-1.23-3.64,.66-1.34,2.29-1.9,3.64-1.23,3.61,1.78,8.26,1.71,11.84-.18,3.63-1.91,6.21-5.58,6.73-9.58,.19-1.49,1.56-2.54,3.05-2.34,1.49,.19,2.54,1.56,2.34,3.05-.74,5.72-4.42,10.96-9.59,13.68-1.37,.72-2.82,1.26-4.31,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.98,402.78c-1.69,2.62-3.56,5.05-5.45,7.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M325.04,403.51c-1.63,2.92-3.03,6.08-3.11,9.42s1.4,6.89,4.35,8.46c3.49,1.86,8.02,.42,10.8-2.39,2.78-2.81,4.19-6.67,5.35-10.44,1.22-3.95,2.27-8.01,2.24-12.14,0-1.39-.57-3.69-1.59-6.09-1.29-3.03-5.31-3.73-7.49-1.27-4,4.52-8.29,10.4-10.55,14.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M488.54,373.99c3.53,3.97,7.26,8.1,12.58,9.43,2.24,.56,4.66,.45,6.78-.47,6.63-2.87,5.92-10.61,2.07-14.94-2.93-3.29-7.22-4.99-11.46-6.2-5.11-1.46-11.01-2.81-16.63-2.97-2.94-.08-4.6,3.26-2.73,5.53,2.92,3.54,7.24,7.18,9.4,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M448.19,434.95c4.62-3.46,10.7-4.91,16.38-3.9,7.44,1.32,14.57,7.1,16.45,14.61,.52,2.08,.36,4.44-.92,6.15-1,1.33-2.55,2.14-4.15,2.61-5.42,1.6-11.48-.18-16.36-2.66-3.51-1.78-1-3.64-4.51-5.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M416.36,442.67c-2.57-1.77,1.03-4.47-1.75-3.04s-11.99,7.29-13.92,9.74c-3.27,4.16-6.35,8.41-6.78,13.68-.42,5.28,2.54,11.15,7.68,12.4,3.75,.92,7.76-.79,10.56-3.45,2.8-2.66,4.64-6.16,6.42-9.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M443.9,483.89c.51,3.02,.73,6.29-.7,9.01-.3,.58-.67,1.08-1.06,1.55-5.17-3.31-10.14-5.11-14.14-6.08,.02-.03,.05-.08,.06-.1,3.04-5.19,4.28-11.44,3.39-17.38l7.72-1.92c2.25,4.72,3.85,9.77,4.73,14.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M476.94,485.59c-1.09,1.71-3.04,2.76-5.04,3.16-2.01,.41-4.08,.23-6.09-.04-.43-.05-.84-.13-1.27-.18-.57-.11-1.17-.23-1.76-.38,1.24-3.7,3.91-9.2,9.49-14.5,.61,.36,1.21,.77,1.76,1.23,.07,.03,.13,.08,.18,.13,3.06,2.56,4.88,7.22,2.72,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M472.27,473.63c-5.59,5.31-8.25,10.81-9.49,14.5-2.02-.47-3.94-1.25-5.52-2.57-5.12-4.33-4.52-12.8-9.13-17.67l6.72-5.73c1.28,3.76,5.01,6.12,8.69,7.65,2.92,1.23,6.04,2.16,8.74,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.43,435.75c-2.49,6.64-2.03,13.93-1.28,20.98,.55,5.2,1.24,10.73,4.59,14.74,3.47,4.17,9.24,5.84,14.66,5.62,5.42-.22,10.62-2.08,15.73-3.92,6.1-2.2,13.02-5.25,14.7-11.51,1.18-4.42-.72-9.02-2.58-13.21-2.34-5.27-4.51-10.62-7.08-15.79-2.35-4.74-4.94-8.73-10.52-9.81-3.33-.64-6.78-.2-10.11,.5-3.6,.76-7.18,1.82-10.36,3.67-3.43,2-6.35,4.96-7.76,8.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M442.14,494.45c-.22,.27-.47,.53-.72,.76-2.37,2.25-5.91,3.36-9.17,4.26-1.76,.48-3.75,.95-5.33,.04-1.85-1.06-2.35-3.58-1.81-5.64,.34-1.35,1.04-2.57,1.78-3.73,.36-.61,.75-1.19,1.1-1.77,4.01,.97,8.97,2.77,14.14,6.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 381.99,
    cy: 354.32,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 427.72,
    cy: 343.6,
    r: 5.04
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 308,
    cy: 512.23,
    r: 7.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 284.69,
    cy: 517.7,
    r: 7.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 331.32,
    cy: 506.76,
    r: 7.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M454.1,598.79l-65.05-69.27,125.78-29.49-27.47,90.97c-4.39,14.53-22.87,18.87-33.26,7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M451.84,514.93l12.18,51.93c-1.67,.39-3.52-.04-4.85-1.47l-40.15-42.76,32.83-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M484.67,507.23l-16.96,56.15c-.56,1.87-2.03,3.08-3.69,3.47l-12.18-51.93,32.83-7.7Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 452.01,
    y1: 515.03,
    x2: 451.95,
    y2: 514.77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M712.47,4.37l-12.55,19.63-48.44,75.59-40.6-34.47,70.44-47.2L708.45,.43c2.57-1.54,5.51,1.34,4.01,3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M712.63,36.38s-55.61,71.46-71.85,84.73c-8.44,6.92-30.78,6.07-43.28-5.9-11.52-11.04-13.77-33.45-6.4-41.81C607.52,54.8,676.77,.38,676.77,.38c1.08-.9,2.65,.2,2.18,1.52l-6.61,18.46c-.51,1.41,1.06,2.66,2.32,1.85l6.66-4.29-70.44,47.2,40.6,34.47,48.44-75.59-9.61,15.04c-.83,1.3,.53,2.9,1.95,2.28l18.25-8.04c1.87-.62,3.38,1.59,2.12,3.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 625.82,
    cy: 89.25,
    r: 27.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 626.6,
    cy: 75.62,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 610.52,
    cy: 84.82,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 620.47,
    cy: 96.31,
    r: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M117.38,202.67c-33.55,8.9-67.95-11.08-76.86-44.62-2.46-9.26-2.71-18.59-1.09-27.42,.81-4.4,2.08-8.67,3.79-12.76,13.86,11.74,32.24,24.44,51.96,35.89,19.27,11.19,38.83,20.62,55.61,26.84-2.72,3.5-5.81,6.71-9.25,9.58-6.83,5.71-15,10.06-24.17,12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M150.8,180.6c-16.79-6.22-36.35-15.66-55.61-26.84-19.72-11.45-38.1-24.15-51.96-35.89h0c1.95-4.72,4.47-9.18,7.51-13.27,2.61-3.55,5.59-6.81,8.9-9.74,7.09-6.29,15.73-11.05,25.51-13.65,33.55-8.9,67.95,11.08,76.86,44.62,2.58,9.71,2.73,19.48,.84,28.69-.88,4.34-2.23,8.55-3.99,12.57-2.1,4.83-4.81,9.37-8.05,13.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 101,
    cy: 123.33,
    r: 6.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 96.92,
    cy: 100.41,
    r: 4.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 114.89,
    cy: 100.31,
    r: 4.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.94,196.53c.97-1.68,1.09-3.8,.44-6.27-2.28-8.58-13.86-21.51-31.53-35.75-.88,4.34-2.23,8.55-3.99,12.57,.78,.65,1.53,1.29,2.28,1.93,8.41,7.24,13.82,13.03,17.11,17.25,.57,.72-.07,1.76-.97,1.59-4.32-.8-13.6-2.71-22.29-5.74-1.37-.48-2.76-.98-4.18-1.51-16.79-6.22-36.35-15.66-55.61-26.84-19.72-11.45-38.1-24.15-51.96-35.89h0c-.45-.39-.89-.76-1.33-1.13-8.51-7.33-13.95-13.17-17.23-17.4-.55-.71,.04-1.73,.93-1.61,4.98,.71,12.31,2.37,22.45,5.91,.88,.31,1.78,.63,2.68,.96,2.61-3.55,5.59-6.81,8.9-9.74-26.56-10.24-46.27-13-50.55-5.64-.97,1.68-1.09,3.8-.44,6.27,2.24,8.46,13.53,21.14,30.78,35.15,13.41,10.9,30.43,22.59,49.6,33.72,18.63,10.82,36.72,19.61,52.51,25.83,27.48,10.83,48.01,13.89,52.38,6.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M671.57,194.03c-4.37-4.58-10.9-6.88-19.25-7.08-27.36-.64-74.48,21.22-130.83,59.41-3.27,2.22-6.58,4.49-9.91,6.82,12.78,6.72,24.75,14.76,35.75,23.96,.63-.42,1.25-.84,1.87-1.27,2.09-1.39,4.17-2.76,6.25-4.11,30.35-19.75,53.41-31.43,69.64-37.89,2.78-1.11,5.44,1.82,4.1,4.48-6.45,12.8-20.89,40.15-38.3,64.62-2.28,3.21-4.65,6.46-7.09,9.75-.47,.65-.96,1.3-1.45,1.96-34.79,46.93-82.16,99.62-134.76,149.79-1.78,1.69-3.55,3.38-5.34,5.06-.25,.24-.5,.48-.75,.71-24.22,22.86-48.92,44.57-73.19,64.42-27.83,22.77-55.11,43.1-80.5,59.92h-.03c-1.6,1.08-3.16,2.11-4.74,3.13-30.72,20-53.97,31.71-70.21,38.12-2.74,1.07-5.39-1.7-4.19-4.37,6.75-14.96,18.65-36.41,38.95-64.96,1.79-2.49,3.59-5.01,5.46-7.53-1.06-1.38-2.1-2.77-3.12-4.18-11.49-3.7-21.29-11.3-27.86-21.16-50.38,68.52-73.32,122.75-55.15,141.8,4.37,4.59,10.9,6.89,19.25,7.08,28.55,.68,78.57-23.13,138.17-64.43,39.63-27.44,83.48-62.6,128.07-103.42h.01c.11-.11,.22-.21,.34-.32,7.46-6.83,14.94-13.82,22.42-20.96,50.88-48.53,94.9-97.2,128.77-141,2.61-3.38,5.17-6.73,7.66-10.05,53.7-71.57,78.71-128.63,59.96-148.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M249.93,554.79c-11.49-3.7-21.29-11.3-27.86-21.16,2.77-3.77,5.62-7.59,8.56-11.44,5.42,11.49,11.89,22.39,19.3,32.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M816.2,527.93c0,1.6,.64,3.05,1.69,4.09,1.05,1.05,2.49,1.7,4.09,1.7h4.52c3.42,0,6.2,2.78,6.2,6.2,0,1.72-.69,3.27-1.82,4.39-1.12,1.12-2.67,1.82-4.38,1.82h-20.76c-3.38,0-6.12,2.74-6.12,6.13,0,1.69,.68,3.23,1.79,4.33,1.11,1.11,2.64,1.79,4.33,1.79h26.95c-7.9,6.38-17.94,10.19-28.89,10.19-3.02,0-5.98-.3-8.85-.85-10.01-1.95-18.85-7.13-25.39-14.42-3.44-3.82-6.25-8.22-8.26-13.04h25.52c1.77,0,3.36-.71,4.52-1.87,1.15-1.15,1.87-2.76,1.87-4.52,0-3.53-2.86-6.4-6.39-6.4h-28.8c-.18-1.63-.26-3.28-.26-4.95,0-25.43,20.61-46.04,46.04-46.04s45.83,20.41,46.03,45.66h-27.85c-3.2,0-5.78,2.59-5.78,5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.84,522.53c0,.64-.01,1.29-.04,1.93-.13,3.13-.57,6.19-1.3,9.13h0c-2.44,9.93-8.1,18.57-15.81,24.79h-26.95c-1.69,0-3.22-.68-4.33-1.79-1.11-1.11-1.79-2.64-1.79-4.33,0-3.38,2.74-6.13,6.12-6.13h20.76c1.71,0,3.27-.69,4.38-1.82,1.13-1.12,1.82-2.67,1.82-4.39,0-3.42-2.78-6.2-6.2-6.2h-4.52c-1.6,0-3.05-.65-4.09-1.7-1.05-1.04-1.69-2.49-1.69-4.09,0-3.2,2.59-5.78,5.78-5.78h27.85c0,.12,0,.25,0,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M793.22,533.87c0,1.77-.72,3.36-1.87,4.52-1.16,1.16-2.75,1.87-4.52,1.87h-25.52c-1.68-4.01-2.8-8.3-3.28-12.79h28.8c3.53,0,6.39,2.87,6.39,6.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 769.72,
    y: 510.5,
    width: 23.97,
    height: 7.61,
    rx: 3.81,
    ry: 3.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M639.77,432.41l-5.83,18.52c-.66,2.09-3.34,2.69-4.82,1.07l-13.12-14.31c-1.48-1.62-.66-4.23,1.48-4.71l18.96-4.21c2.14-.48,3.99,1.55,3.34,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M640.17,445.21l-18.96,4.21c-2.14,.48-3.99-1.55-3.34-3.64l5.83-18.52c.66-2.09,3.34-2.69,4.82-1.07l13.12,14.31c1.48,1.62,.66,4.23-1.48,4.71Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSpaceIllustration);
export default __webpack_public_path__ + "static/media/Hero_Space_Illustration.58707c494da677ae64f117e396a2ffb3.svg";
export { ForwardRef as ReactComponent };